module.exports = __webpack_public_path__ + "img/117.96353545.jpg";